"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("../../actions/types");
var _utils = require("../../utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function overlays() {
  var _payload$overlays;
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
    payload = action.payload;
  switch (type) {
    case "".concat(_types.GET_BROADCAST, "_SUCCESS"):
    case "".concat(_types.SYNC_OVERLAYS, "_SUCCESS"):
    case "".concat(_types.UPDATE_OVERLAYS, "_SUCCESS"):
    case "".concat(_types.BROADCAST_SYNC_LAYER_SOURCES, "_SUCCESS"):
      return payload.overlays;
    case "".concat(_types.BROADCAST_SET_PROGRAM, "_SUCCESS"):
      if ((payload === null || payload === void 0 || (_payload$overlays = payload.overlays) === null || _payload$overlays === void 0 ? void 0 : _payload$overlays.length) > 0) {
        return payload.overlays;
      }
      return state;
    case "".concat(_types.BROADCAST_UPLOAD_OVERLAY, "_SUCCESS"):
    case "".concat(_types.BROADCAST_CREATE_OVERLAY, "_SUCCESS"):
      return [].concat(_toConsumableArray(state), _toConsumableArray(payload));
    case "".concat(_types.BROADCAST_DELETE_OVERLAY, "_SUCCESS"):
    case _types.BROADCAST_DELETE_OVERLAY:
      return state.filter(function (overlay) {
        return overlay._id !== payload;
      });
    case "".concat(_types.BROADCAST_TOGGLE_OVERLAY_HIDDEN, "_SUCCESS"):
      return (0, _utils.toggleOverlayStatus)(payload, state);
    case _types.BROADCAST_TOGGLE_OVERLAY_STATUS:
      return payload;
    case "".concat(_types.BROADCAST_UPDATE_OVERLAY_STATE, "_SUCCESS"):
      var updatedOverlay = _toConsumableArray(state).map(function (overlay) {
        if (overlay._id === payload._id) {
          return _objectSpread(_objectSpread({}, overlay), {}, {
            source: payload.source
          });
        }
        return overlay;
      });
      return updatedOverlay;
    case "".concat(_types.BROADCAST_UPDATE_OVERLAY_POSITION, "_SUCCESS"):
      var updatedState = _toConsumableArray(state).map(function (overlay) {
        if (overlay._id === payload._id) {
          return _objectSpread(_objectSpread({}, overlay), {}, {
            layer: payload.layer
          });
        }
        return overlay;
      });
      return updatedState;
    default:
      return state;
  }
}
var _default = exports["default"] = overlays;